import { jsx as _jsx } from "react/jsx-runtime";
const Spinner = ({ size, color, additionalClasses = [] }) => {
    return (_jsx("span", { className: `loading loading-spinner ${size} text-${color} ${additionalClasses.join(" ")}`, "aria-label": "Loading", role: "status" }));
};
export default Spinner;
